import React from "react";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import tableStyle from "../../assets/jss/material-dashboard-react/components/tableStyle.jsx";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import PropTypes from "prop-types";

const ShowVehicle = props => {
  let { data } = props;
  const { classes, tableHeaderColor } = props;
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        <TableHead
          className={classes[tableHeaderColor + "TableHeader"]}
          style={{ color: "#8e24aa" }}
        >
          <TableRow>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              ID
            </TableCell>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              Vehicle Types
            </TableCell>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              Vehicle Category
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(item => {
            return (
              <TableRow key={item.id}>
                <TableCell className={classes.tableCell}>{item.id}</TableCell>
                <TableCell className={classes.tableCell}>
                  {item.vehicleType}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {item.vehicleCategory}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Link
                    to={{
                      pathname: `/vehicle/edit/${item.id}`
                    }}
                  >
                    Edit
                  </Link>
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => props.onDelete(item)}
                >
                  Delete
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
ShowVehicle.defaultProps = {
  tableHeaderColor: "gray"
};

ShowVehicle.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
export default withStyles(tableStyle)(ShowVehicle);



// WEBPACK FOOTER //
// ./src/admin/vehicle/showVehicle.jsx